import React from 'react';

const FrontBanner = () => {
  return (
    <div className="front-banner">
        <div className='title'>
        <h1>Ia-tă 4 motive să alegi serviciile noastre:</h1>
        </div>
      <div className="row">
        <div className="container">
        <h1>1. REPARAȚII PROFESIONALE</h1>
        <ul>
    <li>Repararea pompelor de vacuum și pompelor de înaltă presiune de pe vidanje.</li>
    <li>Înlocuirea pieselor uzate sau defecte, inclusiv garnituri, filtre, valve și piese de schimb de înaltă calitate.</li>
    <li>Diagnosticul rapid al problemelor tehnice, urmat de soluții eficiente care restabilesc funcționarea optimă a echipamentelor.</li>
  </ul>
        </div>
        <div className="container">
        <h1>2. ÎNTREȚINERE PREVENTIVĂ</h1>
        <ul>
    <li>Revizii periodice pentru a preveni defectarea pompelor și pentru a prelungi durata de viață a echipamentelor.</li>
    <li>Curățarea și verificarea sistemelor de vacuum și presiune pentru a evita defecțiuni costisitoare.</li>
    <li>Inspecții detaliate ale componentelor critice ale pompelor.</li>
  </ul>
        </div>
      </div>
      <div className="row">
        <div className="container">
        <h1>3. INSTALARE ȘI CONFIGURARE</h1>
        <ul>
    <li>Instalarea de noi pompe de vacuum și pompe de înaltă presiune pentru vidanje.</li>
    <li>Configurarea corectă a echipamentului pentru a asigura o performanță maximă.</li>
    <li>Consiliere și recomandări pentru alegerea celor mai potrivite echipamente în funcție de nevoile specifice ale fiecărui client.</li>
  </ul>        </div>
        <div className="container">
        <h1>4. CONSULTANȚĂ TEHNICĂ</h1>  <ul>
    <li>Asistență tehnică pentru alegerea celor mai bune soluții pentru întreținerea și repararea pompelor.</li>
    <li>Formare pentru personalul care operează vidanjele, pentru o utilizare corectă și sigură a echipamentelor.</li>
  </ul> */        </div>
      </div>
    </div>
  );
};

export default FrontBanner;